import { getUserAgent } from '@subflow-frontend/utils/useragent/getUserAgent';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material';

export function useDeviceData() {
  const [userAgent, setUserAgent] = useState(window.navigator.userAgent);
  useEffect(() => {
    const handleResize = () => {
      setUserAgent(window.navigator.userAgent);
    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return getUserAgent(userAgent);
}

export function useDeviceType() {
  const deviceData = useDeviceData();
  if (deviceData.isDesktop) {
    return 'desktop';
  } else if (deviceData.isTablet) {
    return 'tablet';
  } else {
    return 'mobile';
  }
}

export function useDeviceType2() {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  if (isXs) {
    return 'mobile';
  } else if (isSm) {
    return 'tablet';
  } else {
    return 'desktop';
  }
}
